import { render, staticRenderFns } from "./EmployeeForm.vue?vue&type=template&id=4f87cab8&"
import script from "./EmployeeForm.vue?vue&type=script&lang=ts&"
export * from "./EmployeeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports